import React from 'react';
import { ButtonColor, ButtonType, LinkType } from '../../../CoreUI/Buttons/Interfaces/Buttons.interface';
import {
  ProductCatalogServiceTypes,
  EntitlementServiceTypes,
  RealmsSubscriptionServiceTypes,
  RealmsProfileServiceTypes,
  RealmStatus as StatusOfRealm,
  RealmState as StateOfRealm
} from 'minecraft-net-core-services';
import { TabLabelProps } from '../Components/CoreUI/TabLabel/TabLabel';
import { PurchaseTabView } from '../Components/CoreUI/PriceTab/PurchaseTab';

export interface IOneStoreWalletStore {}

export interface IOneStoreComponentTitle {
  componentTitle: string;
}

export interface IHeroComponentProps {
  heroDetailText?: string;
  showRealmsLogoImg?: boolean;
  classNames?: string | string[];
}

export interface IRealmPanel {
  panelTitle: string;
}
export interface IAgreementPanel {
  setDisableButton?: React.Dispatch<React.SetStateAction<boolean>>;
  showTermsAndConditions?: boolean;
}

export interface ITransferSubscriptionPanel extends ISubscriptionPanel {}

export type Realmtype = 'java-purple' | 'java-subscription' | 'java-yellow' | 'java-gray' | '';
export type RealmBackground = 'dark' | 'mid' | 'light';

export interface IRealmsData {
  title?: string;
  realmType?: Realmtype;
  price?: string;
  altClassName?: string;
  background?: RealmBackground;
  realmId?: string;
  subscriptionType?: string;
  trialProductName?: string;
  primaryAction?: 'link' | 'button';
  primaryActionCta?: string;
  primaryActionAriaLabel?: string;
  primaryActionLink?: string;
  primaryActionType?: ButtonType;
  primaryActionColor?: ButtonColor;
  secondaryActionColor?: ButtonColor;
  secondaryActionType?: ButtonType;
  primaryActionCallback?: () => void;
  isPrimaryActionDisabled?: boolean;
  isSecondaryActionDisabled?: boolean;
  secondaryAction?: 'link' | 'button';
  secondaryActionCta?: string;
  secondaryActionBtnAriaLabel?: string;
  secondaryActionLink?: string;
  secondaryActionCallback?: () => void;
  isSecondaryActionLink?: boolean;
  primaryAemContentName?: string;
  secondaryAemContentName?: string;
  canceledText?: string;
  hideSecondaryAction?: boolean;
  backButtonContentName?: string;
  primaryActionLinkType?: LinkType;
  secondaryActionLinkType?: LinkType;
  canEditRealm?: boolean;
  realmsSettingsCTA?: string;
  realmsSettingsCtaAriaLabel?: string;
  editRealmLink?: string;
}

export interface IButton {
  title: string;
  ariaLabel: string;
  ctaLink: string;
  isBtnDisabled: boolean;
}

export interface IBuyRealmsCard {
  realms: IRealmsData;
}

export interface IPopUpOverProps {
  message: string;
  id: number;
  isDisabled: boolean;
  infoBtnAriaLabel: string;
  aemContentName?: string;
}

export interface IRealmsParams extends IRealmsData, IAlertComponentParams {
  isRealmCardVisible: boolean;
  realmCard?: IRealmsData;
}

export interface IAlertComponentParams {
  message: string;
  isPopOverVisible: boolean;
  isPopUpDisabled?: boolean;
  popOverMessage?: string;
  index?: number;
  aemContentName?: string;
  infoBtnAriaLabel: string;
  type: 'alert' | 'warning' | 'info';
}

export interface IRealmSelectorList {
  realmData: IRealmSubscriptionObj[];
  setSubscriptionId: (subscriptionId: string) => void;
}

export interface IAddNewRealmComponent {
  realmName: string;
  realmStatus: string;
  isDisabled: boolean;
}

export interface IApiResponseType<IApiResponse> {
  status: number;
  data: IApiResponse;
}

export type RealmStatusType = 'UNKNOWN' | 'SUBMITTED' | 'ACTIVE' | 'INACTIVE' | 'EXPIRED' | 'IN_DUNNING' | 'FAILED' | 'IN_GRACE_PERIOD';

export type IRealmStatus = RealmsSubscriptionServiceTypes.IRealmStatus;

export { StatusOfRealm as RealmStatus };

export { StateOfRealm as RealmState };

export type IRedeemApiResponseParams = RealmsSubscriptionServiceTypes.ApiSubscriptionsRedeemReturnParams;
export type ApiSubscriptionsRedeemParams = RealmsSubscriptionServiceTypes.ApiSubscriptionsRedeemParams;
export type ApiRealmsProfileReturnParams = IRealmsProfileReturnParams[];
export type IRealmsProfileReturnParams = RealmsProfileServiceTypes.RealmsProfileReturnParams;

export type IUnreconciledRealmsList = RealmsSubscriptionServiceTypes.ApiCheckSubscriptionsReturnParams;
export type IApiGetSubscription = RealmsSubscriptionServiceTypes.IApiGetSubscription;
export interface IRealmsProductInformation {
  result: IApiGetSubscription;
  continuationToken: string;
  profileVersion: number;
}
export type IRealmSubscriptionObj = {
  createdDate?: string;
  expirationDate?: string;
  id: string;
  status: RealmStatusType;
  store: 'Legacy' | 'OneStore' | 'Internal' | 'Support';
  world: {
    id: string;
    name: string;
    state: 'CLOSED' | 'OPEN' | 'ADMIN_LOCK' | 'UNINITIALIZED' | 'DELETED';
    daysLeft: number;
    paymentIsActive?: boolean;
    paymentStatus?: 'Active' | 'Canceled';
  };
};

export interface ISubscriptionPanel extends IAgreementPanel, IRealmsData {
  showBackButton?: boolean;
  tabLabel?: TabLabelProps;
  purchaseTabView?: PurchaseTabView;
}
export type IProductInformation = ProductCatalogServiceTypes.ApiProductInformationReturnParams;
export interface IErrorComponentProps {
  errorTitle: string;
  subTitle: string;
  errorDescription: string;
  errorImage: string;
  errorCtaText: string;
  errorCtaLink: string;
}

export type ApiEntitlementReturn = EntitlementServiceTypes.ApiEntitlementReturn;

export type ApiEntitlementItem = EntitlementServiceTypes.ApiEntitlementItem;

export interface ILegacyRealmId {
  id: string;
  realmId: string;
}

export interface IRealmStatusDetail {
  active: number;
  inactive: number;
  uninitialized: number;
}
export interface IRealmStatusData {
  legacy: IRealmStatusDetail;
  onestore: IRealmStatusDetail;
}
